import { DateTime } from 'luxon';
import { QSpinner, QText } from '@qualio/ui-components';

const ActiveDateFilter = ({ value }: { value: unknown }) => {
  if (typeof value !== 'string') {
    return <QSpinner size="sm" />;
  }
  const dt = DateTime.fromISO(value, { setZone: true });
  if (!dt.isValid) {
    return <QSpinner size="sm" />;
  }
  return <QText as="span">{dt.toFormat('d LLL yyyy')}</QText>;
};

export default ActiveDateFilter;
